import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-company-billing',
  templateUrl: './company-billing.component.html',
  styleUrls: ['./company-billing.component.css']
})
export class CompanyBillingComponent implements OnInit {

  authToken = localStorage.getItem('auth');

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  routeID = this.route.snapshot.params.businessID;
  openingID = this.route.snapshot.params.openingID;
  currentUserId = this.authService.getTokenData().userID;
  billings = [];
  finalSum = 0;
  opening;

  constructor( 
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) { }

  ngOnInit(): void {
    this.fetchBilling();
  }

  fetchBilling() {
    //Epoch time

    //Get first day of the month at 00:00:00
    var date = new Date();
    var epoch = date.getTime();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var firstDayEpoch = firstDay.getTime();

    //Get current state of the month
    var date = new Date();
    var epoch = date.getTime();

    var end_path = '?start=' + firstDayEpoch + '&end=' + epoch;


    this.http.get(environment.COMPANY_BILLING+ '/' + this.routeID + end_path, this.httpOptions).subscribe(
      (res: any) => {
        console.log(res);
        if(res.status == 200 ) {
          this.billings = res.message;

          for (let i = 0; i < this.billings.length; i++) {
            var bill = this.billings[i];
            
            bill.name = this.formateName(bill.type);

            this.finalSum += bill.price;
          }

          //Set start and end date

          (<HTMLInputElement>document.getElementById('start')).value = firstDay.toISOString().slice(0,10);
          (<HTMLInputElement>document.getElementById('end')).value = date.toISOString().slice(0,10);

         
        }
        else {
          console.log('buu')
          this.billings = [];
        }
        
      }, (err: any) => {

      }
    )
  }

  searchByDates(){
    var start = (<HTMLInputElement>document.getElementById('start')).value;
    var end = (<HTMLInputElement>document.getElementById('end')).value;

    var startEpoch = new Date(start).getTime();
    var endEpoch = new Date(end).getTime();
    //Add one day to end date
    endEpoch = endEpoch + 86400000;
    var end_path = '?start=' + startEpoch + '&end=' + endEpoch;

    this.http.get(environment.COMPANY_BILLING+ '/' + this.routeID + end_path, this.httpOptions).subscribe(
      (res: any) => {
        console.log(res);
        if(res.status == 200 ) {
          this.billings = res.message;

          for (let i = 0; i < this.billings.length; i++) {
            var bill = this.billings[i];
            bill.name = this.formateName(bill.type);

            this.finalSum += bill.price;
          }
        }
        else {
          console.log('buu')
          this.billings = [];
        }
        
      }, (err: any) => {

      }
    )
  }

  formateName(name) {
    if(name){
      switch(name){
        case 'marketplace_leave':
          return 'Marketplace ilmoitus';
        case 'marketplace_bid':
          return 'Marketplace tarjous';
        case 'wishlist_profile_opening':
          return 'Toiveen avaus';
        case 'feed_ads':
          return 'Mainos';
        case 'application_profile_opening':
          return 'Hakemuksen avaus';
        case 'headhunting_profile_opening':
          return 'Headhunting avaus';
        case 'company_pinning':
          return 'Logo mobiiliappin etusivulle';
        default:
          return name;

      }
    }
  }

}
